var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% - (64px))"}},[_c('Sidebar'),_c('Toolbar'),_c('div',{staticClass:"layout-padding"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }